@if (order) {
  <div>
    <div class="order-table table-align-center table-align-center-fixed w-100">
      @if (order?.id) {
        <div>
          <div>
            {{ 'ORDER_CODE' | translate }}
          </div>
          <div class="align-middle">
            <div class="d-flex align-items-end">
              <span class="pe-2">{{ order.id }}</span>
              <span class="position-relative text-decoration-none order-type-link">
                @if (this.order.category?.id == 1) {
                  <img [title]="this.order.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_zayavka.png" />
                }
                @if (this.order.category?.id == 2) {
                  <img [title]="this.order.category?.value" style="width: 20px; height: 20px" src="/assets/images/icon_incident.png" />
                }
                <div class="order-type">
                  <p class="order-type-heading">Изменить тип заявки</p>
                  <ul class="m-0 p-0 list-unstyled text-nowrap">
                    <li>
                      <span class="order-type-item d-flex align-items-center mb-2 w-100">
                        <img src="/assets/images/icon_zayavka.png" alt="" />
                        <span class="ps-2">Заявка</span>
                        <span class="order-type-current">текущий</span>
                      </span>
                    </li>
                    <li>
                      <span class="order-type-item d-flex align-items-center mb-2 w-100">
                        <img src="/assets/images/icon_incident.png" alt="" />
                        <span class="ps-2">Инцидент</span>
                      </span>
                    </li>
                    <li>
                      <span class="order-type-item d-flex align-items-center w-100">
                        <img src="/assets/images/icon_request.png" alt="" />
                        <span class="ps-2">Проектный запрос</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </span>
            </div>
          </div>
        </div>
      }
      <!-- <div *ngIf="this.authService.checkPermission(this.permissions.orders_create_canedit_servicetype)">
      <div>{{"CATEGORY" | translate}}</div>
      <div>
        <dx-select-box [items]="serviceTypes$ | async"
          [(value)]="order.category.id"
          [displayExpr]="getCategoryFieldName()"
          valueExpr="id"
          [disabled]="orderUIService.isDisabled(order)">
          <dx-validator>
            <dxi-validation-rule type="required" message="{{'FIELD_IS_REQUIRED' | translate}}"></dxi-validation-rule>
          </dx-validator>
        </dx-select-box>
      </div>
    </div> -->
      <div>
        <div>
          {{ 'DATE_CREATE' | translate }}
        </div>
        <div>
          {{ order.createDate | date: 'dd-MM-yyyy' }}
        </div>
      </div>
      <div>
        <div>
          {{ 'STATUS' | translate }}
        </div>
        <div>
          {{ order.status?.name }}
        </div>
      </div>
      <div>
        <div>{{ 'IT_SERVICE_CATEGORY' | translate }}</div>
        <div>
          {{ this.getServiceCategoryName() }}
        </div>
      </div>
      <div>
        <div>{{ 'IT_SERVICE' | translate }}</div>
        <div>
          {{ this.getServiceName() }}
        </div>
      </div>
      <div>
        <div>{{ 'THEME' | translate }}</div>
        <div>
          <dx-text-box [(value)]="order.title" [readOnly]="orderUIService.isDisabled(order)">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
      @if (this.authService.checkPermission(this.permissions.orders_create_show_initiator)) {
        <div>
          <div>{{ 'INITIATOR' | translate }}</div>
          <div>
            <dx-select-box
              [dataSource]="dataSourceInitiator"
              [(value)]="valueInitiator"
              displayExpr="fio"
              [minSearchLength]="3"
              [searchEnabled]="true"
              [searchTimeout]="250"
              [showClearButton]="true"
              (onValueChanged)="onValueChangedInitiator()"
              (onOpened)="onOpenedInitiator()"
              [readOnly]="orderUIService.isDisabled(order)">
              <dx-validator>
                <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
              </dx-validator>
            </dx-select-box>
          </div>
        </div>
      }
      <div>
        <div>{{ 'FOR_WHOM' | translate }}</div>
        <div>
          <!--{{order.employeeFor?.fio}}-->
          <dx-select-box
            [dataSource]="dataSourceForWhom"
            [(value)]="valueForWhom"
            displayExpr="fio"
            [minSearchLength]="3"
            [searchEnabled]="true"
            [searchTimeout]="250"
            [showClearButton]="true"
            (onValueChanged)="onValueChangedForWhom()"
            (onOpened)="onOpenedForWhom()"
            [readOnly]="orderUIService.isDisabled(order)">
            <dx-validator>
              <!--<dxi-validation-rule type="required" message="{{'FIELD_IS_REQUIRED' | translate}}"></dxi-validation-rule>-->
            </dx-validator>
          </dx-select-box>
        </div>
      </div>
      <div>
        <div>{{ 'DESCRIPTION' | translate }}</div>
        <div>
          <dx-text-area
            style="width: 100%"
            [autoResizeEnabled]="true"
            [minHeight]="128"
            [maxHeight]="202"
            [(value)]="order.body"
            valueChangeEvent="change"
            [readOnly]="orderUIService.isDisabled(order)">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-text-area>
        </div>
      </div>
      @if (order.mark > 0) {
        <div class="mark">
          <div>{{ 'EFFICIENCY_MARK' | translate }}</div>
          <div><app-mark [value]="order.mark" [isReadOnly]="true"></app-mark></div>
        </div>
      }
    </div>
  </div>
}
